import React, { Fragment, useEffect, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { useBackClose } from '@/hooks/useBackClose'

export default function BottomSheet({
  isOpen,
  onClose,
  title = '',
  customClassName = '',
  childrenClassName = '',
  children,
  onOpen = () => {},
  isHeaderPresent = true
}) {
  const initialRef = useRef(null)
  useBackClose(isOpen ? onClose : undefined);

  useEffect(() => {
    if (isOpen) {
      onOpen()
    }
  }, [isOpen])

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[9999]" onClose={onClose} initialFocus={initialRef}>
        <div style={{ display: 'none' }} ref={initialRef} />
        {/* Background overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-modalWrapper bg-opacity-75 transition-opacity" />
        </Transition.Child>

        {/* Fullscreen container for bottom sheet */}
        <div className="scrollbarHidden fixed inset-0 z-20 overflow-hidden">
          <div className="flex min-h-full items-end justify-center text-center md:items-center">
            {/* Slide-up transition */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="translate-y-full opacity-0"
              enterTo="translate-y-0 opacity-100"
              leave="ease-in duration-150"
              leaveFrom="translate-y-0 opacity-100"
              leaveTo="translate-y-full opacity-0"
            >
              <Dialog.Panel
                className={classNames(
                  'shadow-xl relative w-full transform overflow-hidden rounded-t-[16px] bg-white text-left transition-all',
                  'sm:max-w-lg',
                  customClassName
                )}
              >
                {/* Header */}
                {isHeaderPresent && (
                  <div className="flex items-center gap-4 border-b-[1px] border-l-none border-r-none border-t-none border-solid border-[#E5E5E5] p-[16px]">
                    <div className="flex-1 text-[18px] font-bold leading-27 text-title">
                      {title}
                    </div>
                    <div id="modal_close" className="h-fit w-fit cursor-pointer" onClick={onClose}>
                      <ImageWithBasePath src={'close'} width={24} height={24} alt="close symbol" />
                    </div>
                  </div>
                )}

                {/* Content area */}
                <div className={childrenClassName}>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
